import * as actionTypes from '../actionTypes';
import axios from '../../../services/axios'
import {setMessage} from "../message";

export const loadPersonalAnnouncement = () => {
    return {
        type: actionTypes.LOAD_PERSONAL_ANNOUNCEMENTS
    }
}

export const setPersonalAnnouncement = (personalAnnouncementData) => {
    return {
        type: actionTypes.SET_PERSONAL_ANNOUNCEMENTS,
        personalAnnouncementData: personalAnnouncementData
    }
}

export const getPersonalAnnouncement = () => {
    return (dispatch) => {
        dispatch(loadPersonalAnnouncement())
        axios.get(`/api/v1/announcements`)
            .then(response => {
                dispatch(setPersonalAnnouncement(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}